// extracted by mini-css-extract-plugin
export default {"sidebar":"r_bP","sidebarHeader":"r_bQ","fileinput":"r_bR","form":"r_bS","sponsoredText":"r_bT"};